export const RESET_PASSWORD_TEST_IDS = {
  submitButton: 'auth-reset-password-submit',
} as const;
